import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Row, Card } from 'react-bootstrap';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {Table, Search, FormFields, ButtonFields, ButtonResetFields,InputFields,SelectFields, Loading, ModalComponents } from '../../components/Index';
import { getReportePedidos, getExportarExcel, getReportGragicoPedidos } from '../../services/SalesServices';
import { getComboEmpleado } from '../../services/PersonServices';
import { saveAs } from 'file-saver';
import { showErrorAlert } from '../../utils/helper/AlertService';
import useFormatMoney from '../../hooks/useFomatMoney';
import { CONSTANTS_REPORTES } from '../../constants/Constans';

const search = {
    skip: 1,
    take: 10,
    search: "",
    empleadoId: null,
    fechaInicio:"",
    fechaFin: "",
    tipoServicioId: CONSTANTS_REPORTES.TIPO_SERVICIO_VENTAS,
}

const filterGrafico = {
    anio: new Date().getFullYear(),
    mes: new Date().getMonth() + 1,
    idEmpleado: null,
    idTipoServicio: CONSTANTS_REPORTES.TIPO_SERVICIO_VENTAS,
}

const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = 2000; year <= currentYear; year++) {
        years.push({ value: year, label: year.toString() });
    }
    return years.reverse();
};

const generateMonthOptions = () => {
    const monthNames = ["Todos","Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    return monthNames.map((name, index) => ({
        value: index,
        label: name
    }));
};

export default function ReportSales() {
    const [ serviciosPag, setServiciosPag ] = useState({});
    const [ listaServicio, setListaServicios ] = useState([]);
    const [ paramSearch, setParamSearch ] = useState(search);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ empleado, setEmpleado ] = useState([]);
    const [ mdReporteGrafico, setMdReporteGrafico ] = useState(false);
    const { formatterMoney } = useFormatMoney();
    const [ graficoData, setGraficoData ] = useState([]);
    const handleTableChange = (_, sizePerPage) => {
        setParamSearch({
            ...paramSearch,
            skip:sizePerPage.page,
            take:sizePerPage.sizePerPage,
        })
    }

    const onInputSearch = ({target}) => {
        const { value } = target;
        setParamSearch({...paramSearch, search: value})
    }

    const onSelectGrafico = () => {
        setMdReporteGrafico(true);
        getDataGrafico(filterGrafico);
    }

    const getDataGrafico = async (param) => {
        try{
            setIsLoading(true);
            const data = await getReportGragicoPedidos(param);
            setGraficoData(data);
        }
        catch(e){
            showErrorAlert("Error de servidor, vuelva intentar más tarde");
        }
        finally{
            setIsLoading(false);
        }
    }

    const getData = async (param) => {
        try{
            setIsLoading(true)
            const [ resp_empleado, data ] = await Promise.all([
                getComboEmpleado(''),
                getReportePedidos(param)
            ])
            setEmpleado(resp_empleado);
            setServiciosPag(data);
            setListaServicios(data.items)
        }
        catch(e){
            showErrorAlert("Error de servidor, vuelva intentar más tarde");
        }
        finally{
            setIsLoading(false);
        }   
    }

    const onClickDescargarExcel = async (param) => {
        try{
            setIsLoading(true);
            var data = await getExportarExcel(param);
            setIsLoading(false);
            saveAs(new Blob([data]), 'reporte_compras.xlsx');
        } catch(e){
            showErrorAlert("Error al descargar el Excel");
        }
    }

    useEffect(() => {
        getData(paramSearch)
    },[paramSearch])

    const getChartOptions = () => {
        return {
            chart: { type: 'column' },
            title: { text: 'Cantidad de Ventas por Empleado' },
            xAxis: {
                categories: graficoData.map(d => d.nombreEmpleado),
                crosshair: true,
                title: { text: 'Empleados' }
            },
            yAxis: {
                min: 0,
                title: { text: 'Cantidad de Ventas' }
            },
            tooltip: {
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">Ventas: </td>' +
                    '<td style="padding:0"><b>{point.y}</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y}'
                    }
                }
            },
            series: [{
                name: 'Ventas',
                data: graficoData.map(d => d.totalVentas),
                colorByPoint: true
            }],
            credits: { enabled: false }
        };
    };

    const columns = [
        { 
            dataField: "nombreCliente", 
            text: "Cliente"
        },
        { 
            dataField: "fechaContrato", 
            text: "Fech. Contrato"
        },
		{ 
            dataField: "direccion", 
            text: "Dirección" 
        },
        { 
            dataField: "empleado", 
            text: "Vendedor" 
        },
        { 
            dataField: "deuda", 
            text: "Deuda",
            align: 'right',
            formatter: (cellContent, row) => {
                if (cellContent === 0) {
                    return (
                    <p className="text-primary m-0">Sin Deuda</p>
                    );
                } else if (cellContent > 0 ) {
                    return (
                        <p className="text-danger font-weight-bold m-0">{formatterMoney(row.deuda)}</p>
                    );
                }
            }
        },
        { 
            dataField: "impuesto", 
            text: "IGV",
            align:'right',
            formatter:(_,row) => formatterMoney(row.impuesto)
        },
        { 
            dataField: "precioBruto", 
            text: "Precio Total",
            align:'right',
            formatter:(_,row) => formatterMoney(row.precioBruto)
        },
        { 
            dataField: "coberturaSeguro", 
            text: "Seguro",
            align:'right',
            formatter:(_,row) => formatterMoney(row.coberturaSeguro)
        },
        {   
            dataField: "estadoCodigo", 
            text: "Estado",
            classes: 'py-1',
            formatter: (cellContent, row) => {
                if (cellContent === '01') {
                    return (
                    <label className="badge badge-warning m-0">{row.estado}</label>
                    );
                } else if (cellContent === '02' ) {
                    return (
                    <label className="badge badge-success m-0">{row.estado}</label>
                    );
                }
                else if (cellContent === '03' ) {
                    return (
                    <label className="badge badge-secundary m-0">{row.estado}</label>
                    );
                }
                else if (cellContent === '04' ) {
                    return (
                    <label className="badge badge-danger m-0">{row.estado}</label>
                    );
                }
                else if (cellContent === '05' ) {
                    return (
                    <label className="badge badge-primary m-0">{row.estado}</label>
                    );
                }
                else if (cellContent === '06' ) {
                    return (
                    <label className="badge badge-danger m-0">{row.estado}</label>
                    );
                }
            }
        },
        {
            dataField: "opciones", 
            text: "Opciones",
            sort: false,
            align: 'center',
            classes: 'py-1',
            formatter: (_, row) => {
            return (
                <div>
                    <Link className='text-decoration-none' to={"/services/details-sales/"+row.id}><i className="ti-eye text-primary mr-2" data-toggle="tooltip" data-placement="right" title="Detalle" style={{fontSize:'15px'}}/></Link>
                </div>
            );
            }
        }
    ]
  return (
    <div>
        <Row >
            <div className='col-12'>
                <Card>  
                    <Card.Body>
                        <div className="row mb-4 justify-content-between">
                            <div className = "col-lg-2 d-none d-sm-none d-md-block">
                                <h4 className="card-title float-left mt-2">Reporte Venta</h4>
                            </div>
                            <div className = "col-lg-6 col-ms-12 pb-2">
                                <Search 
                                    onSearchInput={onInputSearch}
                                    value={paramSearch.search}
                                    nameInput='DNI (Cliente/fallecido)'
                                    onRefesh={() => setParamSearch(search)}
                                >
                                    <FormFields
                                        initialValues={paramSearch}
                                        onSubmit={(values) => setParamSearch(values)}
                                    >
                                        <div className='row'>
                                            <div className='col-sm-12 col-md-6 col-lg-6'>
                                                <InputFields
                                                    label={"Fecha Inicio"}
                                                    type="date"
                                                    isRequired={false}
                                                    name="fechaInicio"
                                                    size = "sm"
                                                />
                                            </div>
                                            <div className='col-sm-12 col-md-6 col-lg-6'>
                                                <InputFields
                                                    label={"Fecha Fin"}
                                                    type="date"
                                                    isRequired={false}
                                                    name="fechaFin"
                                                    size = "sm"
                                                />
                                            </div>
                                            <div className='col-12 col-md-6 col-lg-6 mb-2'>
                                                <SelectFields
                                                    isRequired = {false}
                                                    label={"Empleado"}
                                                    name="empleadoId"
                                                    data={empleado.map(item => ({value:item.empleadoId, label: item.nombre}))}
                                                />
                                            </div>
                                            <div className='col-12'>
                                                <ButtonFields title='Buscar'/>
                                                <ButtonResetFields title='Limpiar' onClickCancel={() => setParamSearch(search)}/>
                                            </div>
                                        </div>
                                    </FormFields>
                                </Search>
                            </div>
                            <div className="col-sm-12 col-md-2 col-lg-2">
                                    <button className="btn btn-outline-warning float-right" onClick={() => onSelectGrafico()}>
                                        <i className="fa fa-line-chart mr-2"/>
                                    Gráfico
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-2 col-lg-2">
                                <button className="btn btn-outline-primary float-right" onClick={() => onClickDescargarExcel(paramSearch)}>
                                    <i className="fa fa-file-excel-o mr-2"/>
                                    Exportar
                                </button>
                            </div>
                        </div> 
                        <div className='row mb-2'>
                            <div className='col-sm-12 col-md-3 col-lg-3'>
                                <p className='font-weight-bold'>Precio Total: <span className='text-info'>{formatterMoney(serviciosPag.totalPrecio)}</span> </p>
                            </div>
                            <div className='col-sm-12 col-md-3 col-lg-3'>
                                <p className='font-weight-bold'>Deuda: <span className='text-info'>{formatterMoney(serviciosPag.totalDeuda)}</span></p>
                            </div>
                            <div className='col-sm-12 col-md-3 col-lg-3'>
                                <p className='font-weight-bold'>Total Seguro: <span className='text-info'>{formatterMoney(serviciosPag.totalDeuda)}</span></p>
                            </div>
                            <div className='col-sm-12 col-md-3 col-lg-3'>
                                <p className='font-weight-bold'>Total IGV(18%): <span className='text-info'>{formatterMoney(serviciosPag.totalImpuesto)}</span></p>
                            </div>
                        </div>
                        <Table
                            columns={columns}
                            list={listaServicio}
                            page={serviciosPag.page}
                            sizePerPage={paramSearch.take}
                            totalSize={serviciosPag.total}
                            onTableChange={handleTableChange}
                        />
                        <Loading isLoading = {isLoading}/>
                    </Card.Body>
                </Card>
            </div>
        </Row>
        <ModalComponents
                titulo={"Ventas por Empleado"}
                show={mdReporteGrafico}
                hide={() => setMdReporteGrafico(false)}
                size="xl"
            >
                <Row>
                    <div className="col-md-9">
                        <Card>
                            <Card.Body>
                                <HighchartsReact highcharts={Highcharts} options={getChartOptions()} />
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="col-md-3">
                        <Card>
                            <Card.Header>Filtros</Card.Header>
                            <Card.Body>
                                <FormFields
                                    initialValues={filterGrafico}
                                    onSubmit={(values) => getDataGrafico(values)}
                                >
                                    <div className='row'>
                                        <div className='col-12 mb-2'>
                                            <SelectFields
                                                label={"Año"}
                                                name="anio"
                                                data={generateYearOptions()}
                                            />
                                        </div>
                                        <div className='col-12 mb-2'>
                                            <SelectFields
                                                label={"Mes"}
                                                isRequired = {false}
                                                name="mes"
                                                data={generateMonthOptions()}
                                            />
                                        </div>
                                        <div className='col-12 mb-2'>
                                            <SelectFields
                                                isRequired = {false}
                                                label={"Empleado"}
                                                name="idEmpleado"
                                                data={empleado.map(item => ({value:item.empleadoId, label: item.nombre}))}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <ButtonFields title='Aplicar'/>
                                        </div>
                                    </div>
                                </FormFields>
                            </Card.Body>
                        </Card>
                    </div>
                </Row>
        </ModalComponents>
    </div>
  )
}
